import { cva } from 'class-variance-authority';

export const selectableCardStyles = cva(
  [
    'relative flex h-[115px] w-full flex-col items-center justify-center gap-3 rounded-xl border transition',
    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-300',
  ],
  {
    variants: {
      selected: {
        false: null,
        true: 'cursor-pointer border-blue-300 bg-blue-50',
      },
      disabled: {
        false: null,
        true: 'cursor-not-allowed border-grey-200 bg-grey-100 opacity-60',
      },
      invalid: {
        false: null,
        true: null,
      },
    },
    compoundVariants: [
      {
        selected: false,
        disabled: false,
        invalid: false,
        class: 'cursor-pointer border-grey-400 bg-white hover:border-grey-600',
      },
      {
        selected: false,
        disabled: false,
        invalid: true,
        class: 'cursor-pointer border-red-550 bg-white',
      },
      {
        disabled: false,
        class: 'shadow-card',
      },
    ],
    defaultVariants: {
      selected: false,
      disabled: false,
      invalid: false,
    },
  }
);

export const selectableCardIconStyles = cva('', {
  variants: {
    selected: {
      false: 'text-grey-800',
      true: 'text-blue-700',
    },
  },
  defaultVariants: {
    selected: false,
  },
});

export const selectableCardIndicatorStyles = cva(
  'absolute left-3 top-3 flex h-6 w-6 items-center justify-center rounded-full border',
  {
    variants: {
      selected: {
        false: null,
        true: 'border-blue-300 bg-blue-300 text-white',
      },
      disabled: {
        false: null,
        true: 'border-grey-400 bg-white text-transparent',
      },
    },
    compoundVariants: [
      {
        selected: false,
        disabled: false,
        class: 'border-neutral-800 bg-white text-transparent',
      },
    ],
    defaultVariants: {
      selected: false,
      disabled: false,
    },
  }
);
